import * as PropTypes from "prop-types";
import * as React from "react";
import { rawTheme } from "styles/theme";
import { $, merge } from "glamor";
import { formatMessage } from "lib/globalize-util";
import classNames from "classnames";
import moment from "moment";
import { decodeHtml } from "../../utils/utilities";
import type { IScope } from "reducers/scope";
import { DATATEST } from "constants/integration";
import { WholesalePricingCell } from "./wholesale-pricing-cell";

interface ICatalogDateProp {
    ship_start: number;
    ship_end: number;
}

interface IColumnsProps {
    item: any;
    view: any;
    catalogEntry?: any;
    catalogDates?: ICatalogDateProp;
    priceFieldStyle: any;
    scope: IScope;
}

export class Columns extends React.Component<IColumnsProps, any> {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    private styles = merge(
        {
            display: "flex",
            width: "100%",
            position: "relative",
            top: "35%",
            margin: "0 auto",
        },
        $(" .description", {
            margin: "0px",
            color: rawTheme.palette.darkerGrey,
            height: "20px",
            fontSize: "12px",
            letterSpacing: "0.2px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            float: "left",
            padding: "0 10px",
        }),
        $(" .header", {
            fontWeight: "bold",
        })
    );

    render() {
        const { me } = this.context;
        const { item, view, priceFieldStyle, scope, catalogDates } = this.props;
        const { hideMsrp, hideWholesale } = scope;
        const fields = [];
        const effectiveDate = catalogDates ? moment.utc(catalogDates.ship_start) : undefined;

        if (view) {
            const details = view.sections.get("details");
            if (details) {
                details.elements.forEach((element, i) => {
                    const elementWidth = element.getWidth();

                    const fieldStyles = {
                        minWidth: `${elementWidth}px`,
                        width: `${elementWidth}px`,
                    };

                    fields.push(
                        <div key={i} className={classNames("description", { header: !item })} style={fieldStyles}>
                            {item ? decodeHtml(element.getValue(item)) : element.label}
                        </div>
                    );
                });
            }

            if (view.sections.get("msrp") && !hideMsrp) {
                const msrpCurrency = me.isGuestBuyer() ? scope.brand.settings.default_currency : me._activeMSRPCurrency;
                fields.push(
                    <div
                        key="msrp"
                        className={classNames("description", { header: !item })}
                        style={priceFieldStyle}
                        data-test={DATATEST.PRODUCT.PRICES.MSRP}
                    >
                        {item ? item.formattedMSRPRange(msrpCurrency, scope, effectiveDate) : formatMessage("MSRP")}
                    </div>
                );
            }

            if (view.sections.get("pricing") && !hideWholesale) {
                fields.push(
                    <WholesalePricingCell
                        key="wholesale-pricing-cell"
                        item={item}
                        priceFieldStyle={priceFieldStyle}
                        scope={scope}
                        activeCurrency={me._activeCurrency}
                        shipStart={effectiveDate?.valueOf()}
                    />
                );
            }
        }

        return <div {...this.styles}>{fields}</div>;
    }
}
